export const FILTERS = {
    UNACKNOWLEDGED: 'UNACKNOWLEDGED',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
};

export const FILTER_DISPLAY_MAPPINGS = {
    [FILTERS.UNACKNOWLEDGED]: 'Unacknowledged',
    [FILTERS.ACKNOWLEDGED]: 'Acknowledged ',
};
